import { Action } from 'redux'
import { BonusInstanceResponse } from '../../communication/PlayerApiProtocol.generated'
import { assign, AsyncState, createAsyncState, handleAsyncError, handleAsyncRequest, ReduxAction } from '../ReduxUtils'
import { BONUS_ERROR, RECEIVE_BONUSES, REQUEST_BONUSES } from './BonusActions'

export interface BonusState extends AsyncState {
    list: BonusInstanceResponse[]
}

const initial: BonusState  = createAsyncState({ list : []})

/**
 * Profile reducer, managing PlayerProfileState part of the application state
 */
export function bonusReducer(state: BonusState = initial, anAction: Action) {
	const action: ReduxAction<any> = anAction as ReduxAction<any>

	switch (action.type) {
	case REQUEST_BONUSES:
		return assign<BonusState>({}, state, {
			lastRequested: action.createdTime,
			list: action.payload,
		})
	case RECEIVE_BONUSES:
		return handleAsyncError(state)
	case BONUS_ERROR:
		return handleAsyncRequest(state, action)
	default:
		return state
	}
}
